import version2 from "./index_v3";

export default version2;
